import {useEffect} from "react";

export function ChunkReload() {
  useEffect(() => {
    function onError(e: ErrorEvent) {
      const msg = String(e.message || "");
      if(msg.includes("Failed to fetch dynamically imported module") || msg.includes("Loading chunk")) {
        if(!sessionStorage.getItem("cc-chunk-reload")) {
          sessionStorage.setItem("cc-chunk-reload", "1");
          window.location.reload();
        }
      }
    }
    window.addEventListener("error", onError);
    return () => window.removeEventListener("error", onError);
  }, []);
  return null;
}
